import React from 'react';
import { GetStartedActionsProvider } from 'contexts/get-started-actions.context';
import GetStartedActionsContent from './content';

const GetStartedActionsLayout = () => {
  return (
    <GetStartedActionsProvider>
      <GetStartedActionsContent />
    </GetStartedActionsProvider>
  );
};

export default GetStartedActionsLayout;
